import styled from 'styled-components';
import { rem } from 'polished';
import { css } from '../../../styles/theme';
import { ButtonStyled } from '../ButtonStyled';

export const ButtonStyledDS = styled(ButtonStyled)`
    padding: 0 ${rem(24)};
    height: ${rem(48)};
    font-size: ${({ theme }) => theme.fontSizes.h5};
    border-radius: ${rem(24)};

    ${({ primary }) =>
        primary &&
        css`
            background: ${({ theme }) => theme.colors.black1};
            color: ${({ theme }) => theme.colors.white};

            svg {
                path {
                    fill: ${({ theme }) => theme.colors.white};
                }
            }

            &:hover,
            &:focus-visible {
                background: ${({ theme }) => theme.colors.primary};
            }
        `}

    ${({ secondary }) =>
        secondary &&
        css`
            background: ${({ theme }) => theme.colors.white};
            border: 1px solid ${({ theme }) => theme.colors.black1};
            color: ${({ theme }) => theme.colors.black1};

            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black1};
                }
            }

            &:hover,
            &:focus-visible {
                background: ${({ theme }) => theme.colors.grey4};
                color: ${({ theme }) => theme.colors.primary};
                border-color: ${({ theme }) => theme.colors.primary};

                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.primary};
                    }
                }
            }
        `}

    ${({ primary, disabled }) =>
        primary &&
        disabled &&
        css`
            background: ${({ theme }) => theme.colors.grey16};
        `}

    ${({ secondary, disabled }) =>
        secondary &&
        disabled &&
        css`
            opacity: 0.4;
        `}
`;
